import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import {Helmet} from "react-helmet";
import {useTranslation} from "react-i18next";
import genie_logo from "../../../assets/images/logo.svg";
import FabLanguageDropdown from "../../shared/language-dropdown/FabLanguageDropdown";

const Maintenance = () => {
    const {t} = useTranslation();

    return (
        <Container component="main" maxWidth="lg"
                   sx={{
                       display: "flex",
                       flexDirection: "column",
                       flexGrow: 1,
                       alignItems: "center",
                       justifyContent: "center",
                       textAlign: "center",
                       py: 4,
                   }}>
            <Helmet>
                <title>Genie</title>
                <meta name="robots" content="noindex, nofollow"/>
            </Helmet>
            <img src={genie_logo} width={300} alt="genie-logo"/>
            <Typography variant="h2" color="primary" fontWeight={600} textAlign="center" sx={{
                fontSize: {xs: "2rem", md: "3.4rem"}
            }} mt={4} mb={1}>
                {t("maintenance_title")}
            </Typography>
            <Typography variant="h6" color="primary" fontWeight={600} textAlign="center" sx={{
                maxWidth: 760,
                fontSize: {xs: "1rem", md: "1.25rem"},
                lineHeight: 1.5,
            }}>
                {t("maintenance_subtitle")}
            </Typography>
            <Typography variant="body1" color="primary" fontWeight={600} textAlign="center" sx={{
                opacity: .76,
                mt: 2,
            }}>
                {t("maintenance_footer")}
            </Typography>
            <FabLanguageDropdown/>
        </Container>
    );
};

export default Maintenance;
